import React from "react";

const stack = [
  { category: "iOS Development", items: ["Swift", "SwiftUI"] },
  { category: "Android Development", items: ["Kotlin", "Jetpack"] },
  { category: "Cross-Platform Development", items: ["Flutter", "React Native"] },
  { category: "Backend Development", items: ["Node.js", "Python", "PostgreSQL", "MongoDB"] },
  { category: "Cloud Platforms", items: ["AWS", "Google Cloud"] },
];

export default function Section6() {
  return (
    <div className="w-full Section6 py-[35px]">
      <div className="container-1280 section6-container w-full px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[100%]">
        <h2 className="text-[22px] md:text-[30px] font-bold leading-[28px] md:leading-[38px] text-center my-[0.67em] text-[#151515]">
          Technologies We Use for Mobile App Development
        </h2>

        <p className="w-full md:w-[75%] mx-auto text-center leading-[22px] text-[#535353] text-sm md:text-base font-open mb-6">
          We choose technology based on your project requirements.
        </p>

        <p className="text-center font-bold text-[#151515] text-sm md:text-base font-open mb-5">
          Our technology stack includes:
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4 mb-8">
          {stack.map((group) => (
            <div
              key={group.category}
              className="bg-[#F5F5F5] rounded-[8px] p-5 text-center"
            >
              <h3 className="text-xs md:text-sm font-bold text-[#cd2122] mb-3 font-open uppercase leading-[18px]">
                {group.category}
              </h3>
              <div className="flex flex-wrap justify-center gap-2">
                {group.items.map((item) => (
                  <span
                    key={item}
                    className="bg-white text-[#535353] text-xs px-3 py-1 rounded-full border border-[#EDEDED] font-open"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <p className="w-full md:w-[75%] mx-auto text-center leading-[22px] text-[#535353] text-sm md:text-base font-open">
          We focus on building scalable solutions instead of using
          technology just because it is popular.
        </p>
      </div>
    </div>
  );
}
